import React from 'react';

import Modal from '@hpstellar/core/Modal';
import Button from '@hpstellar/core/Button';
import Counter from '@hpstellar/core/Counter';
import Cross from '@hpstellar/core/Icons/Cross';

import './filter-modal.less';

export default function FilterModal({ children, isOpen, onModalClose, filterCount, resultsCount, clearFilters }) {
    return (
        <Modal
            aria-describedby="modal_description"
            aria-labelledby="modal_title"
            modalClassName="modalFilterContainer"
            onModalClose={onModalClose}
            // onModalOpen={function noRefCheck() {}}
            isOpen={isOpen}
        >
            <div className="filterHeader">
                <Button className="close" variation="tertiary" data-modal-action="close">
                    <Cross size="s" />
                </Button>
                <Counter className="counter" count={filterCount} size="large" subsetDelimiter="of">
                    Filters Applied
                </Counter>
            </div>
            <div className="filterContent">{children}</div>
            <div className="filterFooter">
                <span className="clear">
                    <Button className="button" variation="tertiary" color="primary" onClick={clearFilters}>
                        CLEAR ALL
                    </Button>
                </span>
                <span className="show">
                    <Button className="button" variation="tertiary" color="white" data-modal-action="close">
                        {`SHOW ${resultsCount} RESULTS`}
                    </Button>
                </span>
            </div>
        </Modal>
    );
}
